import { useNavigate } from "react-router-dom";
import src from "../../../images/cyber.jpg";

function Banner() {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/login");
  };

  return (
    <section
      class="hero h-96"
      style={{
        backgroundImage: `url(${src})`,
      }}
    >
      <div class="hero-overlay bg-opacity-60"></div>

      <div class="hero-content text-center text-neutral-content">
        <div class="max-w-md">
          <h1 class="mb-5 text-5xl font-bold">GEARS PC</h1>

          <p class="mb-5">
            GEARS PC INC. is one of the fastest growing startup based in
            Bangladesh that manufactures RAM, SSD, Batteries, Compute Boards &
            Elements, Displays for Laptops and Desktops. Contact Us to learn
            more.
          </p>
          
          <button onClick={handleClick} class="btn btn-primary">
            Get Started
          </button>
        </div>
      </div>
    </section>
  );
}

export default Banner;
